<template>
  <div class="read-data-table-warp">
    <div class="table-list">
      <el-table :data="tableList" style="width: 100%" v-loading="loading">
        <template slot="empty">
          <!-- 没有数据 -->
          <NoData></NoData>
          <br />
        </template>
        <el-table-column label="标题">
          <template slot-scope="scope">
            {{ scope.row.article_title || '' }}
          </template>
        </el-table-column>
        <el-table-column label="查看时间">
          <template slot-scope="scope">
            {{ scope.row.read_time || '' }}
          </template>
        </el-table-column>
        <el-table-column label="阅读完成率">
          <template slot-scope="scope">
            {{ scope.row.finish_percent ? scope.row.finish_percent + '%' : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="阅读时长(min)">
          <template slot-scope="scope">
            {{ scope.row.duration || '' }}
          </template>
        </el-table-column>
        <el-table-column label="是否转发">
          <template slot-scope="scope">
            {{ scope.row.share_status ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="collection_status" label="是否收藏">
          <template slot-scope="scope">
            {{ scope.row.collection_status ? '是' : '否' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pagination"
      style="background-color: #ffffff"
      layout="total,sizes, prev, pager, next, jumper"
      :total="total"
      :page-size="size"
      :current-page="currentPage"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
import mixin from '../mixin';
import NoData from '@/components/no-data';
import { readInfoPagesApi } from '@/api/setUp';
export default {
  name: 'ReadDataTable',
  components: {
    NoData,
  },
  mixins: [mixin],
  data() {
    return {
      //   api: '/api/doctorPortrait/manager/readInfoPages',
    };
  },
  methods: {
    queryData(data) {
      return readInfoPagesApi(data);
    },
  },
};
</script>

<style scoped lang="scss">
.pagination {
  float: right;
  margin-top: 12px;
}
.pagination >>> .el-pager li.number {
  color: #606266;
}
.pagination >>> .el-pager li.active {
  color: #2f96ff !important;
}
.pagination >>> .el-input__inner {
  width: 46px;
  border-radius: 3px;
  height: 24px;
}

.read-data-table {
  width: 100%;
  margin-top: 25px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  position: relative;
  border-radius: 8px;
  .release-list-header {
    display: flex;
    font-size: 16px;
    width: 100%;
    height: 48px;
    background: #f5f7fa;
    font-family: PingFangSC-Regular;
    .release-list-header-item {
      display: inline-block;
      height: 100%;
      line-height: 48px;
      color: #303133;
      letter-spacing: 0;
      border-radius: 8px;
    }
  }
}
.release-list-body {
  width: 100%;
  min-height: 425px;
  // overflow-y: auto;
  .release-list-noData {
    width: 100%;
    height: 100%;
    text-align: center;
    .release-list-noData-img {
      width: 240px;
      height: 192px;
      margin-top: 100px;
    }
    .release-list-noData-word {
      font-size: 16px;
      color: #909399;
      text-align: center;
      margin-top: 16px;
      height: 22px;
    }
  }
  .release-list-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
    color: #606266;
    display: flex;
  }
  .release-list-item:nth-child(30n) {
    border-bottom: none;
  }
  .item-time {
    height: 57px;
    // line-height: 90px;
    display: table;

    // padding-left: 24px;
    position: relative;
    .item-time-inner {
      padding-right: 20px;
      word-break: break-all;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      text-overflow: ellipsis;
      overflow: hidden;
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      .importName {
        height: 22px;
        margin-top: 10px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #303133;
        letter-spacing: 0;
      }
      .importid {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #909399;
        letter-spacing: 0;
        width: 97px;
        height: 22px;
        margin-top: 2px;
      }
    }
  }
}

.Singleitem-width-1 {
  width: 31%;
  padding-left: 24px;
}
.Singleitem-width-2 {
  width: 14%;
}
.Singleitem-width-3 {
  width: 14%;
}
.Singleitem-width-4 {
  width: 14%;
}
.Singleitem-width-5 {
  width: 14%;
}
.Singleitem-width-6 {
  width: 14%;
}
</style>
